module.exports = __webpack_public_path__ + "img/terroir-moonlit-4-mobile.c1c4b21f.jpg";